exports = module.exports = require("../../../../../web-builder/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._24Qws0fJKu5ktrqQk91AAj{font-size:1.25rem;line-height:1.25rem;margin-right:.5rem}._2HNmjwJMYfQHqkx398JToE{opacity:0.8}._3JN2-Vr8F4QS9Fgt5v-OF_{border-top:1px solid #d8ddeb}._2ECQzldLZkui9RltjxxK6D{border-top:0}\n", ""]);

// exports
exports.locals = {
	"icon": "_24Qws0fJKu5ktrqQk91AAj",
	"lighter": "_2HNmjwJMYfQHqkx398JToE",
	"item": "_3JN2-Vr8F4QS9Fgt5v-OF_",
	"noBorder": "_2ECQzldLZkui9RltjxxK6D"
};